define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'view/AuthenticationOptionView',
	'canvas/LoadingCanvas',
	'amdi18n-loader?!identity/nls/IdentityView_strings',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	AuthenticationOptionView,
	LoadingCanvas,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * IdentityView class
	 */
	return function () {
		var _view;

		_view = (function () {
				var $view = jQuery(
					"<div>" +
							"<div id='skIdS_identity-content-container'></div>" +
					"</div>");
				return $view;
			}());


		// public methods

		this.get = function () {
			return _view;
		};

		this.changeContent = function (content) {
			var $contentContainer = _view.find('#skIdS_identity-content-container'),
				$content = content.get();

			$contentContainer.children().detach();

			$contentContainer
				.prepend($content)
				.find('[autofocus]')
				.focus();
		};

	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/ResolveCloudIDView.js
// module id = 358
// module chunks = 1